import { CellContext } from "@tanstack/react-table"
import { useContext, useMemo } from "react"
import { useTranslation } from "react-i18next"

import { LIVE } from "shared/config/localization/namespaces"

import { TeamMember } from "entities/team-members/types/TeamMember"
import { Team } from "entities/teams/types/Team"
import { ParseKeys } from "i18next"

import { TeamListCell } from "./TeamListCell"
import { TeamListTableFeatures } from "./TeamListTableFeatures"
import { TeamListViewContext } from "./TeamListViewContext"

export function TeamListRoleCell({
  info
}: {
  info: CellContext<TeamListTableFeatures, Team, TeamMember[]>
}) {
  const { t } = useTranslation()
  const { userID } = useContext(TeamListViewContext)

  const roleInTeam = useMemo(() => {
    const value = info.getValue()
    if (userID && value) {
      return value.find(member => member.user?.id === userID)?.role || null
    }
    return null
  }, [userID, info])

  return (
    <TeamListCell info={info}>
      {roleInTeam
        ? (t(`Team.Role.${roleInTeam}` as ParseKeys<typeof LIVE>) as string)
        : "-"}
    </TeamListCell>
  )
}
